import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
// import { TransferHistoryDetailHelper,TransferHistoryDetailState} from './transfer-history-detail.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core'; 
import { TransferhistoryService } from 'src/app/transfers/transferhistory-service/transferhistory.service';
import { PopupDetailHelper, PopupDetailState } from './popup-detail.helper';
// import { TransferhistoryService } from '../transferhistory-service/transferhistory.service';
// import { Transferhistory } from '../transferhistory-service/transferhistory.model';

 
@Component({
 selector: 'app-popup-detail',
  templateUrl: './popup-detail.component.html',
  styleUrls: ['./popup-detail.component.scss'],
  providers : [ PopupDetailHelper]
  })

export class PopUpDetailComponent extends BaseFpxFormComponent<PopupDetailHelper, PopupDetailState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public transferHistoryDetailHelper: PopupDetailHelper,
    public transferhistoryService: TransferhistoryService,
    private validatorService: ValidatorService
    
  ) {
    super(formBuilder, router,controlContainer, transferHistoryDetailHelper);
  }
      protected  readonly paymentId_minLength : any = 0;
      protected  readonly paymentCurrency_minLength : any = 0;
      protected  readonly nextPaymentDate_minLength : any = 0;
      protected  readonly beneName_minLength : any = 0;
      protected  readonly debitAccount_minLength : any = 0;
      protected  readonly creditAccount_minLength : any = 0;
      protected  readonly scheduleType_minLength : any = 0;
      protected  readonly status_minLength : any = 0;
   protected override doPreInit(): void {

   this.addFormControl('paymentId', '',  []   ,
		      [
		        this.validatorService.dataAvailabilityCheck(
		          this.embadedFormMode,
		          'paymentId',
		          this.transferhistoryService,
		          this.dataAvailable$
		        ),
		      ],'blur',0,true,0);			   		 

   this.addFormControl('paymentCurrency', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('nextPaymentDate', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('beneName', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('debitAccount', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('creditAccount', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('scheduleType', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('status', '',  []    ,[],'blur',1,false,0);			   		 
	// this.setDataService(this.transferhistoryService);
  }
 

  protected override doPostInit(): void {
   
  }
  
}
